module.exports = __webpack_public_path__ + "img/schedule.c3fae69a.svg";